import get from "lodash/get"
import React from "react"
import {Transition} from "react-transition-group"
import styled from "styled-components"
import {images} from "../../config"
import {media} from "../styled"

class CustomDropdown extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            value: null,
            isDropDownOpen: false,
            selectedOption: null,
        }
        this.node = React.createRef()
    }

    handleChange = option => {
        const {selectedLanguage} = this.props
        if (option.value === "all") {
            const label = selectedLanguage === "en" ? "All" : "सबै"
            option = {
                value: "", text: label,
            }
        }
        this.setState({selectedOption: option, value: option.value, isDropDownOpen: false})
        this.props.onChange(option.value)
    }

    handleDropdownMenu = () => {
        this.setState({
            isDropDownOpen: !this.state.isDropDownOpen,
        })
    }

    handleClickOutside = (e) => {
        if (this.node.contains(e.target)) {
            return
        }
        if (this.state.isDropDownOpen) {
            this.setState({
                isDropDownOpen: false,
            })
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside, false)

        const {value, options} = this.props
        const updatedSelectedOption = options.find(obj => obj.value === value);
        this.setState({...this.state, selectedOption: updatedSelectedOption})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {selectedLanguage, value, options} = this.props
        
        // translation of selected dropdown value when language changes
        if (prevProps.selectedLanguage !== selectedLanguage) {
            // const {options} = this.props
            const selectedOption = this.state.selectedOption

            if (selectedOption) {
                const updatedVersionOfSelectedOption = options.find(obj => obj.value === selectedOption.value)
                this.setState({...this.state, selectedOption: updatedVersionOfSelectedOption})
            }
        }

        if (prevProps.value !== value) {
            const updatedSelectedOption = options.find(obj => obj.value === value);
            this.setState({...this.state, selectedOption: updatedSelectedOption})
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside, false)
    }

    render() {
        const {label, options} = this.props
        return (
            <div ref={node => {
                this.node = node
            }}>
                <Dropdown className="ward-dropdown">
                    <DropdownButton
                        className={"cursor-pointer"}
                        isDropDownOpen={this.state.isDropDownOpen}
                        onClick={this.handleDropdownMenu}
                    >
                        <Title
                            className="title"
                            isDropDownOpen={this.state.isDropDownOpen}
                        >
                            {get(this.state.selectedOption, "text", label)}
                        </Title>
                        <DropdownIcon isDropDownOpen={this.state.isDropDownOpen}/>
                    </DropdownButton>

                    <Transition
                        in={this.state.isDropDownOpen}
                        timeout={100}
                        mountOnEnter
                    >
                        {state => (
                            <DropdownMenu
                                style={{
                                    ...transitionStyles[state],
                                }}
                            >
                                <ul className="dropdown-list">
                                    {options.map(option => (
                                        <li
                                            onClick={e => this.handleChange(option)}
                                            key={option.value}
                                        >
                                            {option.text}
                                        </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        )}
                    </Transition>
                </Dropdown>
            </div>
        )
    }
}

const Dropdown = styled.span`
  display: block;
  position: relative;
  .filter-label {
    color: var(--color-theme-1);
    cursor: pointer;
    display: block;
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    padding: ${props =>
    props.lang === "en" ? "11px 11px 11px 21px" : "9px 11px 11px 21px"};
    position: relative;
    text-transform: uppercase;
    &:before {
      background: url(${images.icons.sprite}) no-repeat -55px -38px;
      content: "";
      height: 14px;
      left: 0;
      position: absolute;
      top: 13px;
      width: 16px;
    }
    &:after {
      border-top: 4px solid ${props => props.theme.dark.slateGrey};
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      content: "";
      right: -1px;
      position: absolute;
      top: 18px;
    }
  }
  .scrollarea {
    height: 200px;
  }
  .dropdown-list {
    background: #3b4155;
    padding: 10px 0;
    border-radius: 4px;
    width: 136px;
    text-align: center;
    /* height: 200px; */
    /* overflow: scroll; */
    li {
      cursor: pointer;
      & + li {
        border-top: 1px solid ${props => props.theme.dark.slateGrey};
        margin-top: 5px;
        padding: 6px 0 4px;
        font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      }
      
      // &:hover{
      //   background: ${props => props.theme.primary.pissYellow};
      //   color: #fff;
      // }
    }
    
  }
  h3 {
    font-size: ${props => (props.lang === "en" ? "11px" : "14px")};
  }

  .filter-inner-block label,
  .ward-dropdown .title {
    font-size: ${props => (props.lang === "en" ? "13px" : "15px")};
  }

  .filter-inner-block label .radio {
    top: ${props => (props.lang === "en" ? "3px" : "6px")};
  }

  .btn--ghost {
    font-size: ${props => (props.lang === "en" ? "14px" : "16px")};
  }
`

const DropdownMenu = styled.div`
  padding-top: 6px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 0.3s ease-in-out;
  ${media.tabletSmall`left: -2px; right: 0;`};
`

const Title = styled.span`
  background: transparent;
  border: 0;
  color: var(--color-theme);
  display: block;
  font: ${props => props.theme.fontWeight.bold}
    ${props => props.theme.fontSize.sm}px
    ${props => props.theme.fontFamily.sansSerif};
  padding: 7px 8px 7px 10px;
  text-transform: uppercase;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isDropDownOpen
        ? "transparent transparent #5D636D"
        : "#5D636D transparent transparent;"};
  border-width: ${props => (props.isDropDownOpen ? "0 4px 4px" : "4px 4px 0")};
  border-style: solid;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`

const DropdownButton = styled.div`
  align-items: center;
  display: flex;
  height: 35px;
  justify-content: space-between;
`

const transitionStyles = {
    entered: {
        boxShadow: 'var(--shadow-dropdown)',
        opacity: 1,
        visibility: "visible",
        transform: "translateY(0)",
    },
}

export default CustomDropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js